import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, ContentCardProps, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';

import { CollectionTooltip } from '../tooltip/CollectionTooltip';
import { CollectionsCardPrivateIndicator } from './CollectionsPrivateIndicator';
import { ICollectionInfo } from './ICollectionInfo';


export class CollectionCard extends ContentCard {


  public render() {
    const { content, addContentFavorite, removeContentFavorite } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        {renderCollectionCardContent(this.props)}
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={content.name}>
            { content.name }
          </span>
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.collectionDetails()}
            />
          </span>
          <span>
            <FavoriteToggle isTabbable={true}
                            isFavorite={content.favorite}
                            onAddFavorite={() => addContentFavorite({ ...content, contentType: 'collection' })}
                            onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'collection' })}/>
          </span>
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderPopoverContent = () => <CollectionTooltip content={this.props.content}
                           urls={this.props.urls} />;
}

// This is a separate function so other card components can reuse the collection thumbnail
export function renderCollectionCardContent(contentCardProps: ContentCardProps): JSX.Element {
  const shouldDisplayPrivateIndicator = (contentCardProps.content as ICollectionInfo).visibility === 'private';

  return (
    <div>
      <div className={CardViewStyles.CollectionCardInfoLayout}>
        <div className={CardViewStyles.CollectionCardTitleArea}>
          <div className={CardViewStyles.CollectionCardTitleText}>{contentCardProps.content.name}</div>
        </div>
        <div style={{ flexGrow: 1 }} />
        <div
          className={CardViewStyles.CollectionCardTypeLabelArea}
          style={{backgroundColor: !(contentCardProps.hovered || contentCardProps.selected) && TabStyles.Colors.White}}
        >
          <span className={CardViewStyles.CollectionCardTypeLabel}>{Messages.collection()}</span>
          {shouldDisplayPrivateIndicator && <CollectionsCardPrivateIndicator />}
        </div>
      </div>
      <Thumbnail navigateUrl={getContentUrlForItem(contentCardProps.content, contentCardProps.urls)}
        defaultImageUrl={imgPath('Blue_Gray_Gradient.png')}
        hovered={contentCardProps.hovered}
        selected={contentCardProps.selected}
        imageCoverBackground={true}
        allowDragAndDrop={contentCardProps.allowDragAndDrop}
        aria-label={contentCardProps.content.name}
      />
    </div>);
}
